import Home from "./Home"
import Saved from "./Saved"
import Templates from "./Templates"

export default Home
export { Saved, Templates }
